module.exports = __webpack_public_path__ + "img/about_swiper4.f78bd173.jpg";